import React, { PureComponent } from "react";
import AppConfig from "../../config/appconfig.json";
// import $ from "jquery";

class PaypalPaymentModule extends PureComponent {
    constructor(props) {
        super(props);
        this.handleCallback = this.handleCallback.bind(this);
    }

    componentDidMount() {
        const $Script = require("scriptjs");
        const totalAmount = parseFloat(this.props.totalAmount).toString();
        const onSuccessCallback = this.handleCallback;
        let paypalSecretSandbox = '', paypalSecretProd = '';
        if (this.props.customerType === "Residential") {
            paypalSecretSandbox = AppConfig.PAYPAL_ACCOUNT_RESIDENTIAL;
            paypalSecretProd = AppConfig.PAYPAL_LIVE_ACCOUNT_RESIDENTIAL;
        }
        else if (this.props.customerType === "Commercial") {
            paypalSecretSandbox = AppConfig.PAYPAL_ACCOUNT_COMMERCIAL;
            paypalSecretProd = AppConfig.PAYPAL_LIVE_ACCOUNT_COMMERCIAL;
        }
        paypalSecretSandbox += '';
        paypalSecretProd += '';

        let paypalEnv = '';
        if (AppConfig.PAYPAL_IS_SANDBOX) {
            paypalEnv = 'sandbox';
        } else {
            paypalEnv = 'production';
        }

        $Script(
            [
                "https://www.paypalobjects.com/api/checkout.js"
            ],
            function () {
                // console.log("loaded");
                window.paypal.Button.render({
                    // Configure environment
                    env: paypalEnv,
                    client: {
                        sandbox: paypalSecretSandbox,
                        production: paypalSecretProd
                    },
                    // Customize button (optional)
                    locale: 'en_US',
                    style: {
                        label: 'paypal',
                        size: 'small',    // small | medium | large | responsive
                        shape: 'rect',     // pill | rect
                        color: 'gold',     // gold | blue | silver | black
                        tagline: false
                    },

                    // Set up a payment
                    payment: function (data, actions) {
                        return actions.payment.create({
                            transactions: [{
                                amount: {
                                    total: totalAmount,
                                    currency: 'SGD'
                                }
                            }]
                        });
                    },
                    // Execute the payment
                    onAuthorize: function (data, actions) {
                        return actions.payment.execute().then(function (payment) {
                            // Show a confirmation message to the buyer
                            window.alert('Thank you for your purchase! Transaction ID:' + payment.transactions[0].related_resources[0].sale.id);
                            //window.alert('Thank you for your purchase!');
                            handlePaymentSuccess(payment.transactions[0].related_resources[0].sale.id);
                            // onSuccessCallback(payment.transactions[0].related_resources[0].sale.id);
                        });
                    },
                    onCancel: function (data, actions) {
                        window.alert('Payment is cancelled');
                    },
                    onError: function (data, actions) {
                        console.log(data);
                        console.log(actions);
                        window.alert('An error has occurred');
                    }
                }, '#paypal-button');
            }
        );

        function handlePaymentSuccess(ref) {
            onSuccessCallback(ref);
        }
    }

    handleCallback(ref) {
        // console.log(ref);
        this.props.onPaymentSuccess(ref);
    }

    render() {
        return (
            <div>{this.props.isShowPaypalButton ? (<div id="paypal-button"></div>) : <div>Not available</div>}</div>
        );
    }
}

export default PaypalPaymentModule;


// WEBPACK FOOTER //
// ./src/components/payment/PaypalPaymentModule.js